import React, { Component } from 'react';
import { Container, Button, Row, Col, Input } from 'reactstrap';
import CompanyContext from '../../auth/CompanyContext';
import ConfirmButton from '../../components/Modal/ConfirmButton';
import * as utilities from '../../utilities';

class DemographicsEntry extends Component {
    static contextType = CompanyContext;

    constructor(props) {
        super(props);

        this.fields = [
            { name: 'Primary Business Name', label: '', type: 'text' },
            // { name: 'SEC#', label: '', type: 'text' },
            { name: 'Organization CRD#', label: '', type: 'text' },
            { name: 'Main Office Street Address 1', label: '', type: 'text' },
            { name: 'Main Office Street Address 2', label: '', type: 'text' },
            { name: 'Main Office City', label: '', type: 'text' },
            { name: 'Main Office State', label: '', type: 'text' },
            { name: 'Main Office Postal Code', label: '', type: 'text' },
            { name: 'Main Office Telephone Number', label: '', type: 'text' },
            { name: 'Main Office Facsimile Number', label: '', type: 'text' },
            { name: 'Website Address', label: '', type: 'text' },
            { name: 'Firm Type', label: '', type: 'text' },
            { name: 'SEC Status Effective Date', label: '', type: 'date' }
        ]

        this.state = {
            isChanged: false
        }
    };

    handleChange = () => {
        fetch('/api/demographics/' + this.props.secID, {
            method: 'PUT',
            body: JSON.stringify(this.props.data),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then((results) => {
                if (results.data) {
                    utilities.addToast('Company successfully added.', 5, 'success');
                    this.setState({
                        isChanged: false
                    })
                    this.props.setUnsavedChanges(false);
                }
            })
    }

    handleDelete = () => {
        fetch('/api/demographics/' + this.props.secID, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then((results) => {
                if (results.data) {
                    utilities.addToast('Company successfully deleted.', 5, 'success');
                    this.props.history.push({
                        pathname: `/companies/`,
                        // state: {

                        // }
                    });
                }
            })
    }

    render() {
        return (
            <Container className="mt-4">
                {this.fields.map(field => (
                    <Row key={field.name} className="my-2">
                        <Col>{field.label !== '' ? field.label : field.name}</Col>
                        <Col>
                            <Input
                                name={field.name}
                                type={field.type}
                                value={this.props.data[field.name] != null ? this.props.data[field.name] : ''}
                                onChange={(e) => {
                                    this.props.onChange(e)
                                    this.setState({
                                        isChanged: true
                                    });
                                }}
                            />
                        </Col>
                    </Row>
                ))}
                <Row className="mt-4">
                    <Col><ConfirmButton color="danger" onClick={this.handleDelete}>Delete Company</ConfirmButton></Col>
                    <Col><Button disabled={!this.state.isChanged} color="primary" onClick={this.handleChange}>Submit Company</Button></Col>
                </Row>
            </Container>
        );
    }
}

export default DemographicsEntry;
